// extracted by mini-css-extract-plugin
export var card = "_qv-0";
export var content = "_qv-2";
export var details = "_qv-3";
export var icon = "_qv-1";
export var iconBlue = "_qv-5";
export var iconBrand = "_qv-4";
export var iconGrayBlue = "_qv-6";
export var iconGreen = "_qv-7";
export var iconIndigo = "_qv-8";
export var iconOrange = "_qv-9";
export var iconPurple = "_qv-a";
export var iconRed = "_qv-b";
export var iconWarning = "_qv-c";